import Radio from '../assets/icons/radio.svg'
import { ReactComponent as RadioFilled } from '../assets/icons/radio-filled.svg'
import { useEffect, useState } from 'react'

function TimerModal({ close, currentPage, api }) {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval)
          return 100
        }
        return prevProgress + 2
      })
    }, 100)
    const timeout = setTimeout(() => {
      close()
      // api()
    }, 5000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div
    // className={`absolute left-0 top-0 flex h-full w-full items-center justify-center overflow-auto ${content === 'focusWhileIndividual' ? '' : 'z-[999] bg-dimmer-default'}`}
    >
      <div className='board:bottom-[98px] tab:bottom-64 tab:modal_sm modal_xs board:modal_default tab:w-[320px] board:w-[400px] board:gap-32 tab:gap-20 absolute bottom-[44px] right-42 w-[240px] gap-16 overflow-hidden'>
        <div className='flex flex-col items-start gap-4'>
          <p className='board:text-h1-semibold tab:text-h2-semibold whitespace-pre-wrap text-caption-semibold text-label-default'>
            {`현재 ${currentPage} 페이지에서 개별 활동 중입니다. 수업 집중을 실행할까요?`}
          </p>
          <p className='text-caption2-long-regular board:text-body1-long-regular tab:text-body2-long-regular whitespace-pre-wrap text-label-info'>
            개별 활동을 진행하고 있는 학생들이 선생님이 보고 있는 화면을 따라오게 됩니다.
          </p>
        </div>
        <div className='board:gap-16 flex w-full gap-8'>
          <button
            onClick={close}
            // className=''
            className='button_outlined_secondary text-caption2-medium board:text-h2-semibold board:text-label-sub tab:rounded-10 tab:py-12 tab:text-body2-semibold w-full text-nowrap rounded-6 py-8 text-label-sub'
          >
            페이지 계속 보기
          </button>
          <button
            onClick={async () => {
              await api()
              close()
            }}
            className='button_solid_primary board:bg-primary-normal text-caption2-medium board:text-h2-semibold tab:rounded-10 tab:py-12 tab:text-body2-semibold w-full text-nowrap rounded-6 bg-primary-normal py-8'
          >
            수업 집중 실행
          </button>
        </div>
        <div className='tab:h-12 absolute bottom-0 right-0 h-8 w-full bg-fill-strong'>
          <div
            className={`h-full bg-primary-normal`}
            style={{
              width: `${progress}%`,
              transition: 'width 0.1s ease',
            }}
          />
        </div>
      </div>
    </div>
  )
}

function DefaultModal({ close, content, api, currentPage, students }) {
  const textList = {
    individual: {
      title: '개별 활동을 실행할까요?',
      description: `해당 ${currentPage} 페이지에 대해 수업 참여자 ${students}명의 개인
보드가 생성되고 참여자는 지정된 보드로
이동됩니다.`,
      deactivate: '취소',
      activate: '실행',
    },
    individualAlready: {
      title: '개별 활동을 실행할까요?',
      description: `해당 ${currentPage} 페이지에 대한 개인 보드가 이미 생성되어 있습니다. 실행 시 새로 추가된 학생이 있을 경우 보드 생성가 생성되며, 학생들은 지정된 보드로 이동됩니다.`,
      deactivate: '취소',
      activate: '실행',
    },
    focus: {
      title: '수업 집중을 실행할까요?',
      description: `개별 활동을 진행하고 있는 학생들이 선생님이 보고 있는 화면을 따라오게 됩니다.`,
      deactivate: '취소',
      activate: '실행',
    },
    focusWhileIndividual: {
      title: `현재 ${currentPage} 페이지에서 개별 활동 중입니다. 수업 집중을 실행할까요?`,
      description: `개별 활동을 진행하고 있는 학생들이 선생님이 보고 있는 화면을 따라오게 됩니다.`,
      deactivate: '페이지 계속 보기',
      activate: '수업 집중 실행',
    },
    startClass: {
      title: `아직 예정된 수업 교시가 아닙니다
수업을 시작할까요? `,
      description: `수업 시작을 실행하면 학생들이 수업방에 입장할 수 있습니다.`,
      deactivate: '취소',
      activate: '수업 시작',
    },
    delete: {
      title: '보드를 삭제할까요?',
      description: `선택한 보드를 정말로 삭제할까요? 자료와 판서를 포함한 보드가 완전히 삭제되며 복구할 수 없습니다.`,
      deactivate: '취소',
      activate: '삭제',
    },
    logout: {
      title: `수업을 종료하였습니다
로그아웃할까요?`,
      description: `전자칠판을 사용하지 않는 경우 보안을 위해 선생님 계정 로그아웃을 실행해주세요`,
      deactivate: '메인 페이지로',
      activate: '로그아웃',
    },
  }

  return (
    <div
      className={`absolute left-0 top-0 flex h-full w-full items-center justify-center overflow-auto ${content === 'focusWhileIndividual' ? '' : 'z-[999] bg-dimmer-default'}`}
    >
      <div
        className={`${content === 'delete' ? 'board:right-12 board:bottom-[124px] tab:bottom-[128px] bottom-90 right-8' : 'tab:bottom-64 board:bottom-[98px] bottom-[44px] right-42'} tab:w-[320px] tab:modal_sm modal_xs board:modal_default board:w-[400px] board:gap-32 absolute w-[240px] gap-16 overflow-hidden`}
      >
        <div className='flex flex-col items-start gap-4'>
          <p className='board:text-h1-semibold tab:text-h2-semibold whitespace-pre-wrap text-caption-semibold text-label-default'>
            {textList[content].title}
          </p>
          <p className='text-caption2-long-regular board:text-body1-long-regular tab:text-body2-long-regular whitespace-pre-wrap text-label-info'>
            {textList[content].description}
          </p>
        </div>
        <div className='board:gap-16 tab:gap-12 flex w-full gap-8'>
          <button
            onClick={close}
            // className=''
            className={`${content === 'focusWhileIndividual' ? 'button_outlined_secondary w-full text-nowrap' : 'button_outlined_secondary board:button_outlined_secondary_lg'} tab:text-body2-semibold text-caption2-medium board:text-h2-semibold board:text-label-sub tab:rounded-10 tab:py-12 w-full text-nowrap rounded-6 py-8 text-label-sub`}
          >
            {textList[content].deactivate}
          </button>
          <button
            onClick={async () => {
              if (api) {
                await api()
                close()
              } else {
                close()
              }
            }}
            className={`${content === 'focusWhileIndividual' ? 'button_solid_primary w-full text-nowrap' : 'button_solid_primary board:button_solid_primary_lg'} ${content === 'delete' ? 'board:bg-red-60 bg-red-60' : 'board:bg-primary-normal bg-primary-normal'} tab:text-body2-semibold text-caption2-medium board:text-h2-semibold tab:rounded-10 tab:py-12 w-full text-nowrap rounded-6 py-8`}
          >
            {textList[content].activate}
          </button>
        </div>
      </div>
    </div>
  )
}

function RadioModal({ close, content, postApi, onStateChange, studentsLeaveApi }) {
  // const [action, setAction] = useState('OVERWRITE')
  const textList = {
    exportPDF: {
      title: '보드 PDF로 내보내기',
      option: [
        {
          title: '모든 내용 포함',
          description: '작성한 모든 내용을 포함하여 보드를 내보냅니다.',
          value: 'ALL',
        },
        {
          title: '판서 제외',
          description:
            '작성한 필기, 추가한 이미지 등 판서를 제외하고 배경으로 불러온 내용만 내보냅니다.',
          value: 'EXCEPTION',
        },
      ],
      deactivate: '취소',
      activate: '내보내기',
    },
    exitRoom: {
      title: '수업방 나가기',
      option: [
        {
          title: '학생들을 내보내고 수업 종료',
          description: `모든 학생들이 강제 퇴장되고 수업이 종료됩니다
            수업 종료된 수업방은 다시 접근할 수 없습니다`,
          value: 'EXIT',
        },
        {
          title: '수업방에서 벗어나기',
          description: '학생들은 수업방에 남아있고 수업방을 벗어납니다',
          value: 'LEAVE',
        },
      ],
      deactivate: '취소',
      activate: '확인',
    },
  }

  const [selectedValue, setSelectedValue] = useState(textList[content]?.option[0].value)

  return (
    <div className='fixed left-0 top-0 z-[999] flex h-full w-full items-center justify-center overflow-auto bg-dimmer-default'>
      <div className='tab:modal_sm modal_xs board:modal_default tab:w-[376px] tab:right-12 board:w-[400px] tab:bottom-64 board:bottom-[84px] board:right-20 absolute bottom-[44px] right-8 w-[240px] fill-label-default'>
        <div className='board:gap-24 tab:gap-20 flex flex-col items-start gap-16'>
          <p className='board:text-h1-semibold tab:text-h2-semibold text-caption-semibold text-label-default'>
            {textList[content]?.title}
          </p>
          <div className='tab:gap-8 flex flex-col items-start gap-4'>
            {textList[content]?.option.map((option, index) => (
              <label
                key={index}
                className='tab:py-12 tab:pl-8 tab:pr-16 tab:gap-8 relative flex items-start gap-4 py-6 pl-6 pr-10 has-[:checked]:rounded-8 has-[:checked]:bg-fill-normal'
              >
                <input
                  defaultChecked={option.value === selectedValue}
                  // defaultChecked={selectedValue}
                  // defaultValue={'EXIT'}
                  onChange={(e) => setSelectedValue(e.target.value)}
                  type='radio'
                  name={content}
                  value={option.value}
                  className='tab:h-20 tab:min-w-20 board:h-24 board:min-w-24 peer h-16 min-w-16 appearance-none bg-contain bg-center bg-no-repeat checked:invisible'
                  style={{
                    backgroundImage: `url(${Radio})`,
                  }}
                />
                <RadioFilled className='tab:h-20 tab:w-20 board:h-24 board:w-24 invisible absolute h-16 w-16 peer-checked:visible' />
                <div className='tab:gap-4 flex w-full flex-col items-start justify-center gap-2'>
                  <p className='board:text-h2-semibold tab:text-body1-semibold text-caption-semibold text-label-sub'>
                    {option.title}
                  </p>
                  <p className='text-caption2-long-regular tab:text-body2-long-regular text-label-info'>
                    {option.description}
                  </p>
                </div>
              </label>
            ))}
          </div>
        </div>
        <div className='board:gap-16 tab:gap-12 flex w-full gap-8'>
          <button
            onClick={close}
            className='button_outlined_secondary text-caption2-medium tab:button_outlined_secondary_lg tab:text-label-sub tab:text-body2-semibold w-full rounded-6 py-8 text-label-sub'
          >
            {textList[content]?.deactivate}
          </button>
          <button
            onClick={async (e) => {
              e.preventDefault()
              if (selectedValue === 'EXIT') {
                onStateChange()
                await studentsLeaveApi()
                postApi()
                close()
              } else {
                await postApi()
                close()
              }
            }}
            className={`${content === 'exitRoom' ? 'tab:bg-red-60 bg-red-60' : 'bg-primary-normal'} button_solid_primary text-caption2-medium tab:button_solid_primary_lg tab:text-body2-semibold w-full rounded-6 py-8`}
          >
            {textList[content]?.activate}
          </button>
        </div>
      </div>
    </div>
  )
}

function StudentExitModal({ close, onStateChange }) {
  // const [action, setAction] = useState('OVERWRITE')

  return (
    <div className='fixed left-0 top-0 z-[999] flex h-full w-full items-center justify-center overflow-auto bg-dimmer-default'>
      <div className='modal_xs board:modal_default board:w-[400px] board:bottom-[84px] tab:bottom-64 board:right-20 absolute bottom-[44px] right-8 w-[240px] fill-label-default'>
        <div className='board:gap-24 flex flex-col items-start gap-16'>
          <div className='flex flex-col items-start gap-4'>
            <p className='board:text-h1-semibold text-caption-semibold text-label-default'>
              수업방 나가기
            </p>
            <p className='text-body1-long-regular text-label-info'>
              현재 수업이 진행중입니다. 나가기를 실행하면 수업 듣기를 중단하고 수업방을 나가게
              됩니다.
            </p>
          </div>
          <div className='board:gap-8 flex flex-col items-start gap-4'>
            <label className='board:py-12 board:pl-8 board:pr-16 board:gap-8 relative flex items-start gap-4 py-6 pl-6 pr-10 has-[:checked]:rounded-8 has-[:checked]:bg-fill-normal'>
              <input
                defaultChecked
                // defaultChecked={selectedValue}
                // defaultValue={'EXIT'}
                // onChange={(e) => setSelectedValue(e.target.value)}
                type='radio'
                name={'studentExitRoom'}
                value={'logout'}
                className='board:h-24 board:min-w-24 peer h-16 min-w-16 appearance-none bg-contain bg-center bg-no-repeat checked:invisible'
                style={{
                  backgroundImage: `url(${Radio})`,
                }}
              />
              <RadioFilled className='board:h-24 board:w-24 invisible absolute h-16 w-16 peer-checked:visible' />
              <div className='board:gap-4 flex w-full flex-col items-start justify-center gap-2'>
                <p className='board:text-h2-semibold text-caption-semibold text-label-sub'>
                  계정 로그아웃
                </p>
                <p className='text-caption2-long-regular board:text-body2-long-regular text-label-info'>
                  기기를 반납하는 경우 보안을 위해 로그아웃을 실행합니다.
                </p>
              </div>
            </label>
            <label className='board:py-12 board:pl-8 board:pr-16 board:gap-8 relative flex w-full items-start gap-4 py-6 pl-6 pr-10 has-[:checked]:rounded-8 has-[:checked]:bg-fill-normal'>
              <input
                // defaultChecked={selectedValue}
                // defaultValue={'EXIT'}
                // onChange={(e) => setSelectedValue(e.target.value)}
                type='radio'
                name={'studentExitRoom'}
                value={'exit'}
                className='board:h-24 board:min-w-24 peer h-16 min-w-16 appearance-none bg-contain bg-center bg-no-repeat checked:invisible'
                style={{
                  backgroundImage: `url(${Radio})`,
                }}
              />
              <RadioFilled className='board:h-24 board:w-24 invisible absolute h-16 w-16 peer-checked:visible' />
              <div className='board:gap-4 flex w-full flex-col items-start justify-center gap-2'>
                <p className='board:text-h2-semibold text-caption-semibold text-label-sub'>
                  수업방 벗어나기
                </p>
                <p className='text-caption2-long-regular board:text-body2-long-regular text-label-info'>
                  메인화면으로 이동합니다.
                </p>
              </div>
            </label>
          </div>
        </div>
        <div className='board:gap-16 flex w-full gap-8'>
          <button
            onClick={close}
            className='button_outlined_secondary text-caption2-medium board:button_outlined_secondary_lg board:text-label-sub w-full rounded-6 py-8 text-label-sub'
          >
            취소
          </button>
          <button
            onClick={async (e) => {
              e.preventDefault()
              onStateChange()
            }}
            className={`board:bg-red-60 button_solid_primary text-caption2-medium board:button_solid_primary_lg w-full rounded-6 bg-red-60 py-8`}
          >
            나가기
          </button>
        </div>
      </div>
    </div>
  )
}

export { DefaultModal, RadioModal, TimerModal, StudentExitModal }
